import { AssemblerWizard } from '../assembler/AssemblerWizard';
import { useAccount } from '../../context/AccountContext';
import { Loader } from '../common/PageLoader';

export function AssemblerLayout() {
  const { accountId, isLoading: loading } = useAccount();

  const renderBody = () => {
    if (loading) {
      return (
        <div className="flex-1 flex items-center justify-center text-cmp-ink-2">
          <Loader label="Loading Write" />
        </div>
      );
    }
    if (!accountId) {
      return (
        <div className="flex-1 flex items-center justify-center text-cmp-ink-2">
          No account found.
        </div>
      );
    }
    return <AssemblerWizard accountId={accountId} />;
  };

  return (
    // The whole screen scrolls with the page, under the frosted top bar.
    <div className="ink-page ink-page-flow flex w-full flex-col">
      <div className="flex flex-col flex-1">
        <div className="w-full max-w-full overflow-x-clip relative flex-1 flex flex-col">
          <div className="m-0 w-full relative box-border bg-primary-background flex flex-col flex-1">
            <div className="ink-frame">{renderBody()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
